var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoFactorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F1C400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6896 7.58621H11.7287C11.2038 6.68011 10.2259 6.06897 9.10344 6.06897C7.4275 6.06897 6.06896 7.42751 6.06896 9.10345C6.06896 10.7794 7.4275 12.1379 9.10344 12.1379C10.2259 12.1379 11.2038 11.5268 11.7286 10.6207H13.6552L14.4138 9.86207L15.1724 10.6207L15.931 9.86207L16.6896 10.6207L18.2069 9.10345L16.6896 7.58621ZM7.5862 9.86207C7.16729 9.86207 6.82758 9.52236 6.82758 9.10345C6.82758 8.68454 7.16729 8.34483 7.5862 8.34483C8.00511 8.34483 8.34482 8.68454 8.34482 9.10345C8.34482 9.52236 8.00511 9.86207 7.5862 9.86207Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06895 14.4138V15.931H6.82757V17.4483H7.58619V16.6897H8.34482V17.4483H9.10344V15.931H13.6552C13.6552 17.1879 14.6741 18.2069 15.931 18.2069C17.1879 18.2069 18.2069 17.1879 18.2069 15.931V14.4138C18.2069 13.1569 17.1879 12.1379 15.931 12.1379C14.6741 12.1379 13.6552 13.1569 13.6552 14.4138H6.06895ZM15.1724 14.4138C15.1724 13.9955 15.5127 13.6552 15.931 13.6552C16.3493 13.6552 16.6896 13.9955 16.6896 14.4138V15.931C16.6896 16.3493 16.3493 16.6897 15.931 16.6897C15.5127 16.6897 15.1724 16.3493 15.1724 15.931V14.4138Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoFactorIcon);
export default __webpack_public_path__ + "static/media/twoFactorIcon.0aee56742fd344761aa38cdf6664d70a.svg";
export { ForwardRef as ReactComponent };